import { selectAllExistingBuildingInfo } from "../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../utils/utilBuildings";
export var selectAcresAvailable = function (state) {
    var buildings = selectAllExistingBuildingInfo(state);
    return buildings.filter(utilBuildings.isAcre);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/selectors/selectAcresAvailable.ts
// module id = 307
// module chunks = 3